export function getShortWidthDescription(selectedWidth: string | null | undefined): string {
  if (!selectedWidth) return '';
  const match = selectedWidth.split(' ')[0]?.match(/[a-zA-Z]+/);
  return match ? match[0] : '';
}
